<script lang="ts">
	import Header from './Header.svelte'
	import { get_map, get_related } from 'shared/json_api/get_related'

	export let storefront_header_response: SingleJsonApiResponse<`storefront_menu`>

	const included_map = get_map(storefront_header_response)
	const storefront_menu_items = get_related(included_map, storefront_header_response.data, `storefront_menu_items`)
		.sort((a, b) => a.attributes.sort_order - b.attributes.sort_order)
</script>

<Header {storefront_menu_items} {included_map} />
